import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=54c0ccb2&scoped=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=54c0ccb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0ccb2",
  null
  
)

export default component.exports